// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","title":"App_title__YS7Xx","x":"App_x__1FmLG"};